import http from "./httpService";
import jwtDecode from "jwt-decode";
import { getApiUrl } from "../config";

const apiEndpoint = getApiUrl() + "/auth";
const tokenKey = "token";

interface DecodedToken {
  FullName: string;
  Role: string;
  aud: string;
  cpf: string;
  exp: number;
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": UserRoles;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;
  iss: string;
  jti: string;
  sub: string;
}

async function register(data) {
  return await http.post(`${apiEndpoint}/register`, data);
}
async function login(username, password) {
  const { data: jwt } = await http.post(apiEndpoint + "/login", {
    username,
    password,
  });
  localStorage.setItem(tokenKey, jwt.token);
  http.setJwt(jwt.token);

  return jwt;
}



async function logout() {
  localStorage.removeItem(tokenKey);
  await http.post<void>(apiEndpoint + "/logout");
  http.setJwt(null);
}

async function getSession() {
  const session = await http.get(apiEndpoint + "/getSession");
  console.log("auth session", { session });
  return session;
}

function getCurrentUser(): DecodedToken {
  try {
    const jwt = getJwt();
    const decoded = jwtDecode(jwt) as DecodedToken;
    return decoded;
  } catch (ex) {
    return null;
  }
}

function getJwt() {
  return localStorage.getItem(tokenKey);
}

function isValid(): boolean {
  try {
    const jwt = getJwt();
    const user = jwtDecode(jwt) as DecodedToken;
    var current_time = new Date().getTime() / 1000;
    if (current_time > user.exp) {
      return false;
    }
    return true;
  } catch (ex) { }
  return false;
}

function isInRole(roles): boolean {
  if (!roles || roles.length === 0) {
    return true;
  }
  try {
    const jwt = getJwt();
    const user = jwtDecode(jwt) as DecodedToken;
    return roles.includes(user.Role);
  } catch (ex) {
    return false;
  }
}

const exportObject = {
  login,
  logout,
  getCurrentUser,
  getJwt,
  isValid,
  isInRole,
  getSession,
  register
};

export default exportObject;
